(function () {
    'use strict';

    angular.module("imApp").factory("accessInfoService", ['$ihttp', function ($ihttp) {
        let service = {
            getAccessInfo: function (parms) {
                return $ihttp.post({
                    method: 2621,
                    parameters: parms || {}
                });
            },
            listSubscriptions: function (parms) {
                return $ihttp.post({
                    method: 2622,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
